export const isQuestionCompleted = (question, userId) => {
  const hasCompletedSurvey = question.surveys.some(survey => survey.is_answered);
  const hasComment = question.comments?.some(comment => comment.user_id === userId);

  if (question.hide_tool && !question.surveys?.length) {
    return true;
  }

  if (question.hide_tool) {
    return hasCompletedSurvey;
  }

  if (!question.surveys?.length) {
    return hasComment;
  }

  return hasComment && hasCompletedSurvey;
};

export const isQuestionDone = (question) => {
  const hasCompletedSurvey = question.surveys.some(survey => survey.is_answered);

  if (!question.surveys?.length) {
    return false;
  }

  return hasCompletedSurvey;
};